// extracted by mini-css-extract-plugin
module.exports = {"mainNav":"Header_mainNav__3zHoT","mainLogo":"Header_mainLogo__2PCk3"};